import { render } from "./SVGColor1.vue?vue&type=template&id=bf35c93c"
import script from "./SVGColor1.vue?vue&type=script&lang=js"
export * from "./SVGColor1.vue?vue&type=script&lang=js"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__